import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { RefreshMetricsByRank } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { FunctionComponent } from 'react'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { Context } from '~/state'
import { PureRefreshRank } from './PureRefreshRank'

type RefreshRankProps = {
  context: Context
  dimensions: Dimension[]
  currencySymbol: CurrencySymbol
}

export const RefreshRank: FunctionComponent<RefreshRankProps> = ({ context, dimensions, currencySymbol }) => {
  const analyticsQuery = useAnalyticsQueryTanstack<RefreshMetricsByRank>('refresh.metrics.by.rank', dimensions, context, {})

  return (
    <PureRefreshRank
      isLoading={analyticsQuery.isFetching}
      error={!!analyticsQuery.error}
      empty={!analyticsQuery.isLoading && !analyticsQuery.data?.name.length}
      onRefreshClick={() => analyticsQuery.refetch()}
      rawData={analyticsQuery.data ?? { name: [] }}
      currencySymbol={currencySymbol}
    />
  )
}
